// import React, { useState } from "react";
// import styles from "../styles/DevelopmentChargesCalculator.module.css";
// import { useNavigate } from "react-router-dom";
// import { FaArrowLeft } from "react-icons/fa";

// const DevelopmentChargesCalculator = () => {
//   const [converterType, setConverterType] = useState("Development Charges");
//   const [landUseType, setLandUseType] = useState("Residential");
//   const [developmentType, setDevelopmentType] = useState("Land Development");
//   const [area, setArea] = useState("");
//   const [rate, setRate] = useState("");
//   const [result, setResult] = useState(0);

//   const navigate = useNavigate();

//   const handleBack = () => {
//     navigate(-1);
//   };

//   const handleDropdownChange = (e) => {
//     const selected = e.target.value;
//     setConverterType(selected);

//     const pathMap = {
//       "Area Convertor": "/area-convertor",
//       "Built-up Area Calculator": "/built-up-area-calculator",
//       "Development Charges": "/development-charges",
//       "Premium for Ancillary FSI": "/ancillary-fsi",
//       "⁠Premium for Premium FSI": "/premium-fsi",
//       "ULC Premium": "/ulc-premium",
//     };

//     if (pathMap[selected]) {
//       navigate(pathMap[selected]);
//     }
//   };

//   const calculateCharges = () => {
//     const a = parseFloat(area);
//     const r = parseFloat(rate);
//     let charges = 0;

//     if (!a || !r) {
//       alert("Please enter valid Area and Rate");
//       return;
//     }

//     if (landUseType === "Residential" || landUseType === "Institutional") {
//       charges = developmentType === "Land Development" ? a * r * 0.005 : a * r * 0.02;
//     } else if (landUseType === "Commercial") {
//       charges = developmentType === "Land Development" ? a * r * 0.005 * 2 : a * r * 0.02 * 2;
//     } else if (landUseType === "Industrial") {
//       charges = developmentType === "Land Development" ? a * r * 0.005 * 1.5 : a * r * 0.02 * 1.5;
//     }

//     setResult(charges.toFixed(2));
//   };

//   return (
//     <div className={styles.developmentChargesCalculator_container}>
//       <div className={styles.developmentChargesCalculator_header}>
//         <button
//           className={styles.developmentChargesCalculator_backButton}
//           onClick={handleBack}
//         >
//           <FaArrowLeft />
//         </button>
//         <h2 className={styles.developmentChargesCalculator_title}>Conversion Calculator</h2>
//       </div>

//       <div className={styles.developmentChargesCalculator_dropdownContainer}>
//         <select
//           value={converterType}
//           onChange={handleDropdownChange}
//           className={styles.developmentChargesCalculator_mainDropdown}
//         >
//           <option>Area Convertor</option>
//           <option>Built-up Area Calculator</option>
//           <option>Development Charges</option>
//           <option>Premium for Ancillary FSI</option>
//           <option>⁠Premium for Premium FSI</option>
//           <option>ULC Premium</option>
//         </select>
//       </div>

//       <div className={styles.developmentChargesCalculator_card}>
//         <h3 className={styles.developmentChargesCalculator_sectionTitle}>Development Charges</h3>

//         <div className={styles.developmentChargesCalculator_formGroup}>
//           <label className={styles.developmentChargesCalculator_label}>Land Use Type:</label>
//           <select
//             className={styles.developmentChargesCalculator_select}
//             value={landUseType}
//             onChange={(e) => setLandUseType(e.target.value)}
//           >
//             <option>Residential</option>
//             <option>Commercial</option>
//             <option>Industrial</option>
//             <option>Institutional</option>
//           </select>
//         </div>

//         <div className={styles.developmentChargesCalculator_formGroup}>
//           <label className={styles.developmentChargesCalculator_label}>Development Type:</label>
//           <select
//             className={styles.developmentChargesCalculator_select}
//             value={developmentType}
//             onChange={(e) => setDevelopmentType(e.target.value)}
//           >
//             <option>Land Development</option>
//             <option>Building Development</option>
//           </select>
//         </div>

//         <div className={styles.developmentChargesCalculator_formGroup}>
//           <label className={styles.developmentChargesCalculator_label}>Area (sq.m):</label>
//           <input
//             type="number"
//             className={styles.developmentChargesCalculator_input}
//             value={area}
//             onChange={(e) => setArea(e.target.value)}
//           />
//         </div>

//         <div className={styles.developmentChargesCalculator_formGroup}>
//           <label className={styles.developmentChargesCalculator_label}>Ready Reckoner Rate (₹/sq.m):</label>
//           <input
//             type="number"
//             className={styles.developmentChargesCalculator_input}
//             value={rate}
//             onChange={(e) => setRate(e.target.value)}
//           />
//         </div>

//         <button
//           className={styles.developmentChargesCalculator_submitButton}
//           onClick={calculateCharges}
//         >
//           Submit
//         </button>

//         <h3 className={styles.developmentChargesCalculator_resultTitle}>Development Charges</h3>
//         <p className={styles.developmentChargesCalculator_resultValue}>₹ {result}</p>
//       </div>
//     </div>
//   );
// };

// export default DevelopmentChargesCalculator;



import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { 
  ArrowLeft, 
  Layers, 
  Home, 
  Building2, 
  Factory, 
  School, 
  LandPlot, 
  Coins,
  ChevronRight,
  Info
} from "lucide-react";

const DevelopmentChargesCalculator = () => {
  const [converterType, setConverterType] = useState("Development Charges");
  const [landUseType, setLandUseType] = useState("Residential");
  const [developmentType, setDevelopmentType] = useState("Land Development");
  const [area, setArea] = useState("");
  const [rate, setRate] = useState("");
  const [result, setResult] = useState(0);

  const navigate = useNavigate();
  const handleBack = () => navigate(-1);

  const handleDropdownChange = (e) => {
    const selected = e.target.value;
    setConverterType(selected);
    const pathMap = {
      "Area Convertor": "/area-convertor",
      "Built-up Area Calculator": "/built-up-area-calculator",
      "Development Charges": "/development-charges",
      "Premium for Ancillary FSI": "/ancillary-fsi",
      "⁠Premium for Premium FSI": "/premium-fsi",
      "ULC Premium": "/ulc-premium",
    };
    if (pathMap[selected]) navigate(pathMap[selected]);
  };

  const calculateCharges = () => {
    const a = parseFloat(area);
    const r = parseFloat(rate);
    let charges = 0;

    if (!a || !r) {
      alert("Please enter valid Area and Rate");
      return;
    }

    if (landUseType === "Residential" || landUseType === "Institutional") {
      charges = developmentType === "Land Development" ? a * r * 0.005 : a * r * 0.02;
    } else if (landUseType === "Commercial") {
      charges = developmentType === "Land Development" ? a * r * 0.005 * 2 : a * r * 0.02 * 2;
    } else if (landUseType === "Industrial") {
      charges = developmentType === "Land Development" ? a * r * 0.005 * 1.5 : a * r * 0.02 * 1.5;
    }

    setResult(charges.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  };

  const getLandIcon = () => {
    switch(landUseType) {
      case "Residential": return <Home size={18} />;
      case "Commercial": return <Building2 size={18} />;
      case "Industrial": return <Factory size={18} />;
      case "Institutional": return <School size={18} />;
      default: return <LandPlot size={18} />;
    }
  };

  return (
    /* FIXED: Changed bg to slate-50 for contrast */
    <div className="min-h-screen bg-slate-50 pb-12">
      {/* --- HEADER --- */}
      <div className="bg-white border-b border-slate-200 sticky top-0 z-30">
        <div className="max-w-3xl mx-auto px-4 h-16 flex items-center gap-4">
          <button onClick={handleBack} className="p-2.5 hover:bg-slate-100 rounded-xl transition-all text-slate-600">
            <ArrowLeft size={22} />
          </button>
          <h2 className="text-lg font-black text-slate-900 uppercase tracking-tight">TPH Calc</h2>
        </div>
      </div>

      <main className="max-w-2xl mx-auto px-4 mt-6">
        {/* --- TOOL NAVIGATOR --- */}
        <div className="relative mb-6">
          <Layers className="absolute left-4 top-1/2 -translate-y-1/2 text-orange-500 z-10" size={18} />
          <select
            value={converterType}
            onChange={handleDropdownChange}
            className="w-full bg-white border border-slate-200 rounded-2xl py-4 pl-12 pr-4 font-bold text-slate-700 appearance-none shadow-sm focus:outline-none"
          >
            <option>Area Convertor</option>
            <option>Built-up Area Calculator</option>
            <option>Development Charges</option>
            <option>Premium for Ancillary FSI</option>
            <option>⁠Premium for Premium FSI</option>
            <option>ULC Premium</option>
          </select>
          <ChevronRight className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-300 pointer-events-none" size={18} />
        </div>

        {/* FIXED: Added border-slate-200 and stronger shadow for better definition */}
        <div className="bg-white rounded-[2.5rem] border border-slate-200 shadow-xl shadow-slate-200/60 overflow-hidden">
          <div className="p-8 bg-[#111827] text-white flex justify-between items-center">
            <div>
              <h3 className="text-xl font-black tracking-tight">Development Charges</h3>
              <p className="text-xs text-slate-400 font-bold uppercase tracking-widest mt-1">Estimator Tool</p>
            </div>
            <div className="w-10 h-10 bg-orange-600 rounded-xl flex items-center justify-center">
              <Coins size={20} />
            </div>
          </div>

          <div className="p-8 space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-2">
                <label className="text-[10px] font-black text-slate-400 uppercase ml-1 flex items-center gap-1">
                   {getLandIcon()} Land Use
                </label>
                <select
                  value={landUseType}
                  onChange={(e) => setLandUseType(e.target.value)}
                  className="w-full bg-slate-50 border border-slate-200 rounded-xl p-3.5 font-bold text-slate-700 outline-none"
                >
                  <option>Residential</option>
                  <option>Commercial</option>
                  <option>Industrial</option>
                  <option>Institutional</option>
                </select>
              </div>

              <div className="space-y-2">
                <label className="text-[10px] font-black text-slate-400 uppercase ml-1 flex items-center gap-1">
                   <LandPlot size={16} /> Development Type
                </label>
                <select
                  value={developmentType}
                  onChange={(e) => setDevelopmentType(e.target.value)}
                  className="w-full bg-slate-50 border border-slate-200 rounded-xl p-3.5 font-bold text-slate-700 outline-none"
                >
                  <option>Land Development</option>
                  <option>Building Development</option>
                </select>
              </div>
            </div>

            <div className="space-y-4 pt-4 border-t border-slate-100">
              <div className="relative">
                <label className="text-[10px] font-black text-slate-400 uppercase ml-1 block mb-2 text-center">Total Area</label>
                <div className="relative">
                  <input
                    type="number"
                    placeholder="0.00"
                    value={area}
                    onChange={(e) => setArea(e.target.value)}
                    className="w-full bg-slate-50 border border-slate-200 rounded-2xl p-5 text-center text-3xl font-black text-slate-900 focus:bg-white focus:border-orange-500 outline-none transition-all placeholder:text-slate-200"
                  />
                  <span className="absolute right-6 top-1/2 -translate-y-1/2 text-xs font-bold text-slate-400">sq.m</span>
                </div>
              </div>

              <div className="relative">
                <label className="text-[10px] font-black text-slate-400 uppercase ml-1 block mb-2 text-center">Ready Reckoner Rate</label>
                <div className="relative">
                  <span className="absolute left-6 top-1/2 -translate-y-1/2 text-lg font-bold text-slate-400">₹</span>
                  <input
                    type="number"
                    placeholder="Rate"
                    value={rate}
                    onChange={(e) => setRate(e.target.value)}
                    className="w-full bg-slate-50 border border-slate-200 rounded-2xl p-5 text-center text-3xl font-black text-slate-900 focus:bg-white focus:border-orange-500 outline-none transition-all placeholder:text-slate-200"
                  />
                </div>
              </div>
            </div>

            <button
              onClick={calculateCharges}
              className="w-full bg-orange-600 hover:bg-orange-700 text-white py-5 rounded-2xl font-black text-lg transition-all transform active:scale-[0.98] shadow-lg shadow-orange-200/50"
            >
              Calculate Charges
            </button>
          </div>

          <div className="bg-orange-50 p-8 border-t border-orange-100 text-center">
            <h4 className="text-[10px] font-black text-orange-600 uppercase tracking-widest mb-2 flex items-center justify-center gap-2">
              <Info size={14} /> Total Estimated Charges
            </h4>
            <div className="text-4xl font-black text-slate-900">
              <span className="text-xl mr-1 opacity-40 font-medium">₹</span>
              {result}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default DevelopmentChargesCalculator;